import router from "./router";
import i18n from "./i18n";

export const userModuleRouter = router;
export const userModuleI18n = i18n;
